module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic03.d94a35e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic03.png
// module id = 503
// module chunks = 1